import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const MY_ORDERS_TRACING_ACTIONS = {
  traceResolveExceptionButtonClickOnMyOrders: createAction(
    '[NGRXTrace - Order] Resolve Button Clicked on My Orders',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceResolveExceptionButtonClickOnOrderStatus: createAction(
    '[NGRXTrace - Order] Resolve Button Clicked on Order Status',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceMyOrdersContext: createAction(
    '[NGRXTrace - Order] My Orders Call',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceMyOrdersContextSuccess: createAction(
    '[NGRXTrace - Order] My Orders Call Success',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceMyOrdersContextFail: createAction(
    '[NGRXTrace - Order] My Orders Call Fail',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
